module.exports = __webpack_public_path__ + "media/public/img/staticmap-190639127c62bdef16eff542e6e07497.png";